/**
 * German translations
 */
import type { TranslationKeys } from '../utils/i18n';

export const de: TranslationKeys = {
  controls: {
    maxTime: 'Maximale Zeit',
    maxTimeMinutes: 'Maximale Zeit (Minuten)',
    travelMode: 'Fortbewegungsart',
    speed: 'Geschwindigkeit',
    mapStyle: 'Kartenstil',
    language: 'Sprache',
    share: 'Teilen',
    play: 'Wiedergabe',
    pause: 'Pause',
    restart: 'Neu starten',
    loading: 'Lädt...',
    showControls: 'Steuerelemente anzeigen',
    hideControls: 'Steuerelemente ausblenden',
    expandControls: 'Steuerelemente erweitern',
    collapseControls: 'Steuerelemente reduzieren',
    selectLocationHint: 'Bitte wählen Sie einen Ort auf der Karte aus, um zu beginnen',
  },
  travelModes: {
    driving: 'Fahren',
    walking: 'Gehen',
    cycling: 'Radfahren',
    transit: 'Öffentlicher Verkehr',
  },
  speed: {
    verySlow: '0.1x (Sehr Langsam)',
    slow: '0.25x (Langsam)',
    half: '0.5x (Halb)',
    normal: '1x (Normal)',
    fast: '1.5x (Schnell)',
    veryFast: '2x (Sehr Schnell)',
  },
  mapStyles: {
    streets: 'Straßen',
    satellite: 'Satellit',
  },
  languages: {
    en: 'English',
    'zh-Hans': '简体中文 (Simplified Chinese)',
    'zh-Hant': '繁體中文 (Traditional Chinese)',
    es: 'Español (Spanish)',
    fr: 'Français (French)',
    de: 'Deutsch (German)',
    ja: '日本語 (Japanese)',
    ko: '한국어 (Korean)',
  },
  addressInput: {
    label: 'Adresse Suchen',
    placeholder: 'Adresse eingeben, um Zeitkarte zu berechnen',
    noResults: 'Keine Ergebnisse gefunden',
    loading: 'Vorschläge werden geladen',
  },
  error: {
    retry: 'Wiederholen',
    dismiss: 'Fehler verwerfen',
    somethingWentWrong: 'Etwas ist schiefgelaufen. Bitte aktualisieren Sie die Seite.',
    browserNotSupported: 'Ihr Browser unterstützt diese Anwendung nicht. Bitte verwenden Sie einen modernen Browser.',
    usageLimitReached: 'Sie haben das Beta-Limit von 5 Berechnungen erreicht. Vielen Dank fürs Ausprobieren! Schreiben Sie mir eine DM, wenn Sie an diesem Projekt interessiert sind.',
  },
  progress: {
    minutes: 'Min',
  },
  share: {
    urlCopied: 'URL in die Zwischenablage kopiert!',
    shareUrl: 'URL teilen',
  },
  emailGate: {
    title: 'Bei Zeitkarte Beta anmelden',
    subtitle: 'Geben Sie Ihre E-Mail-Adresse ein, um einen Anmelde-Link zu erhalten',
    emailPlaceholder: 'your.email@example.com',
    emailLabel: 'E-Mail-Adresse',
    sendButton: 'Anmelde-Link Senden',
    sendingButton: 'Anmelde-Link wird gesendet...',
    checkEmailTitle: 'Überprüfen Sie Ihre E-Mail',
    checkEmailMessage: 'Wir haben einen Anmelde-Link an {email} gesendet',
    checkEmailInstruction: 'Klicken Sie auf den Link in der E-Mail, um zur Zeitkarte zu gelangen.',
    checkEmailHelp: 'E-Mail nicht erhalten? Überprüfen Sie Ihren Spam-Ordner oder versuchen Sie es mit einer anderen E-Mail-Adresse erneut.',
    emailRequired: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
    emailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    domainRestriction: 'Wir erlauben nur @gmail.com, @outlook.com und @qq.com E-Mail-Adressen für den Beta-Zugang.',
    domainNotAllowed: 'Der Beta-Zugang ist derzeit auf Gmail-, Outlook- und QQ-E-Mail-Adressen beschränkt',
    typoSuggestion: 'Meinten Sie @{domain}?',
    rateLimitExceeded: 'Zu viele Anfragen. Bitte warten Sie einen Moment und versuchen Sie es erneut.',
    invalidEmailFormat: 'Ungültige E-Mail-Adresse. Bitte überprüfen und erneut versuchen.',
    failedToSend: 'Fehler beim Senden des Anmelde-Links. Bitte versuchen Sie es erneut.',
    magicLinkFailed: 'Fehler beim Senden des Magic-Links: {error}',
    testMeButton: 'Teste mich',
    bannerText: 'Zeitkarte',
    betaTag: 'Beta',
  },
  testCode: {
    title: 'Testcode eingeben',
    subtitle: 'Haben Sie einen Testcode? Geben Sie ihn unten ein, um zu beginnen',
    placeholder: 'Code eingeben',
    button: 'Mit Code fortfahren',
    haveCodeLink: 'Haben Sie einen Testcode?',
    useEmailLink: 'Stattdessen E-Mail verwenden',
    invalid: 'Ungültiger Testcode',
    expired: 'Dieser Testcode ist abgelaufen',
    limitReached: 'Dieser Testcode hat sein Nutzungslimit erreicht',
    optionalEmailTitle: 'Ihren Fortschritt speichern (Optional)',
    optionalEmailSubtitle: 'Möchten Sie Ihre Arbeit speichern? Geben Sie unten Ihre E-Mail ein (oder jetzt überspringen)',
    optionalEmailPlaceholder: 'ihre.email@beispiel.com (optional)',
    skipButton: 'Jetzt überspringen',
    submitEmailButton: 'Fortfahren',
  },
  usageIndicator: {
    template: '{count} Berechnungen übrig',
    loading: 'Laden...',
  },
  disclaimer: {
    loading: 'Laden...',
    title: 'Wichtiger Hinweis',
    content: 'Dies ist ein Beta- und experimentelles Projekt. Alle Kartendaten werden von Mapbox, einem Drittanbieterdienst, bereitgestellt und wurden nicht unabhängig überprüft. Karten können Ungenauigkeiten enthalten und sollten nicht für kritische Entscheidungen verwendet werden. Reisezeitberechnungen sind nur Schätzungen und wurden nicht auf Genauigkeit überprüft. Wir übernehmen keine Verantwortung oder Haftung für Ungenauigkeiten, Fehler oder Folgen, die sich aus der Nutzung dieser Anwendung ergeben.',
    consent: 'Durch die weitere Nutzung dieser Anwendung erkennen Sie alle oben genannten Bedingungen und Haftungsausschlüsse an und akzeptieren sie.',
  },
  intro: {
    title: 'Entdecken Sie Ihre Reichweite',
    message: 'Visualisieren Sie, wie weit Sie in einer bestimmten Zeit von jedem Ort aus reisen können.\n\nSehen Sie Ihre Reisezeit-Erreichbarkeit animiert auf der Karte, um bessere Entscheidungen darüber zu treffen, wo Sie wohnen, arbeiten oder besuchen möchten.',
    step1: 'Suchen oder klicken Sie auf die Karte, um Ihren Startpunkt festzulegen',
    step2: 'Die Karte zeigt Ihre Reisezeit-Erreichbarkeit mit animierten Zonen',
    step3: 'Konfigurieren Sie Ihre Reisezeit und Transportart',
    step4: 'Klicken Sie auf Abspielen, um zu sehen, wie sich Ihre Reichweite im Laufe der Zeit ausdehnt',
    step5: 'Teilen Sie Ihre Visualisierung über einen teilbaren Link mit anderen',
    next: 'Weiter',
    skip: 'Tour überspringen',
    gotIt: 'Verstanden!',
    startTour: 'Tour starten',
  },
};

